import controller from './kform-builder-edit-buttons.controller';
import template from './kform-builder-edit-buttons.html';

const kformBuilderEditButtonsComponent = {
	bindings: {
		component:      '<',
		hideMoveButton: '<?',
	},
	controller,
	template,
	require: {
		builder: '^^?kformBuilderList',
	}
};

export default kformBuilderEditButtonsComponent
